import { CONFIG } from '../../Config/config'
import { authorization } from '../Auth/Auth'

/**
 * Prepare request
 * @returns {Request}
 */
const prepareRequest = (url, method = 'GET', body = null) => {
  const key = authorization.getAPIKey()
  const headers = new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    authorization: `Bearer ${key}`,
  })

  const initParam = { method, headers }

  if (!url.includes('https:')) {
    url = `${
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:3800/dev'
        : CONFIG.DEVELOPER_API_BASE_URL
    }${url}`
  }

  if (body) {
    initParam.body = JSON.stringify(body)
  }

  /* eslint-disable */
  console.log(`Request: [${method}] ${url}`)
  /* eslint-enable */

  return new Request(url, initParam)
}

export const fetchUsersAPIKeys = async () => {
  const clientId = authorization.getUser().client.id
  try {
    const request = prepareRequest(`/keys/${clientId}`, 'GET')
    const res = await fetch(request)
    const result = await res.json()
    return result.data
  } catch (error) {}
}

export const createAPIKey = async type => {
  const request = prepareRequest('/keys', 'POST', {
    type,
  })
  const res = await fetch(request)
  const data = await res.json()
  return data
}

export const updateAPIKey = async (id, status) => {
  const request = prepareRequest('/keys', 'PUT', {
    id,
    status,
  })
  const res = await fetch(request)
  const data = await res.json()
  return data
}
